import { render, staticRenderFns } from "./openOnlineExam.vue?vue&type=template&id=71fac2b1&scoped=true"
import script from "./openOnlineExam.vue?vue&type=script&lang=js"
export * from "./openOnlineExam.vue?vue&type=script&lang=js"
import style0 from "./openOnlineExam.vue?vue&type=style&index=0&id=71fac2b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fac2b1",
  null
  
)

export default component.exports